<template>
  <div class="mobile-app-card card-mobile" v-if="isDisplayed">
    <div class="close-btn">
      <font-awesome-icon icon="times" class="close" @click.prevent="onClose"/>
    </div>
    <div class="label"><span>Free</span></div>
    <div class="card-mobile-content">
      <img src="@/assets/images/start_kidjo.png" alt="Kidjo Icon">
      <img :src="storeImage" alt="Apple Store" @click.self="onCardClick">
    </div>
  </div>
</template>

<script>
  import userUtil from '@/utils/user.util';

  export default {
    data() {
      return {
        cardStyle: null,
        isDisplayed: false,
        storeImage: '',
      };
    },
    computed: {
      isAndroidDevice() {
        return !!navigator.userAgent && /Android/i.test(navigator.userAgent);
      },
      isIosDevice() {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      },
    },
    methods: {
      onCardClick(event) {
        event.preventDefault();
        const androidApp = 'net.kidjo.app.android';
        const iosApp = 'net.kidjo.app.ios'
        window.location.href =
          'https://kidjo.page.link/?link=https://www.kidjo.tv&' + 
          `apn=${androidApp}&amv=158&isi=1095795448&ibi=${iosApp}`+
          '&ofl=https://www.kidjo.tv/app';
      },
      onClose() {
        this.$emit('card:close');
      },
    },
    mounted() {
      this.isDisplayed = this.isIosDevice || this.isAndroidDevice;

      if (this.isDisplayed) {
        this.storeImage = this.isIosDevice
          ? require('@/assets/icons/store_apple.svg')
          : require('@/assets/icons/store_google.svg');
      } else {
        this.$emit('card:close');
      }
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  .card-mobile {
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    border: 3px solid white;
    border-radius: 16px;
    box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, .4);
    aspect-ratio: 7/8;
    width: 220px;
    height: auto;

    &::after {
      display: block;
      padding-top: 100%;
      content: '';
    }

    &::before {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, .5);
      border-radius: 13px;
      backdrop-filter: blur(2px);
      content: '';
    }

    @media (orientation: portrait) {
      width: 160px;

      @media (min-width: $breakpoint-xs) {
        width: 180px;
      }

      @media (min-width: $breakpoint-sm) {
        width: 220px;
      }

      // @media (min-width: $breakpoint-sm) {
      //   width: 260px;
      // }
    }

    @media (orientation: landscape) {
      width: 157px;
      height: 179px;

      @media (max-width: $breakpoint-xs) {
        height: 165px;
        width: 150px;
      }

      @media (max-width: $breakpoint-sm) {
        height: 165px;
        width: 150px;
        // flex: 0 0 130px;
      }
      @media (max-width: $breakpoint-md) {
        height: 165px;
        width: 150px;
        // flex: 0 0 130px;
      }

      @media (min-width: $breakpoint-lg) {
        height: 220px;
        width: 200px;
        border-width: 6px;
      }

      @media (min-width: $breakpoint-2xl) {
        width: 215px;
        height: 235px;
      }
    }
    @media (max-height: 480px) {
      height: 132px;
      width: 120px;
    }
    @media (orientation: portrait) and (max-width: $breakpoint-2xs) {
      height: 165px;
      width: 155px;
    }
    .close-btn {
      position: absolute;
      z-index: 2;
      top: 8px;
      left: 8px;
      color: white;

      svg {
        padding-left: 5px;
        margin: auto 0;
        fill: currentColor;
      }
    }

    .label {
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      padding: 0 6px 4px;
      background: #ef5902;
      border-style: solid;
      border-color: white;
      border-width: 0 0 3px 3px;
      border-bottom-left-radius: 18px;
      border-top-right-radius: 13px;

      span {
        font-family: "Nunito-ExtraBold";
        font-size: 12px;
        color: white;
      }
    }

    .card-mobile-content {
      z-index: 2;
      text-align: center;
      margin: auto;

      img {
        display: block;
        width: 60px;

        @media (min-width: $breakpoint-lg) {
          width: 90px;
        }
      }
    }
  }
</style>
